import theme from '@qnpm/q-theme';
const { font, responsive: { scale } } = theme;
// 获取样式
const getStyle = (needScale) => {
    const fontSize = needScale ? font.size.scaled : font.size.unscaled;
    const lineHeight = needScale
        ? font.lineHeight.scaled
        : font.lineHeight.unscaled;
    const itemCon = {
        alignItems: 'center',
        flex: 1,
        marginHorizontal: scale(2, needScale)
    };
    const topCon = {
        width: scale(30, needScale),
        height: scale(30, needScale),
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
    };
    const topConSmall = {
        width: scale(20, needScale),
        height: scale(20, needScale),
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
    };
    const text = {
        fontSize: fontSize.fontSizeXS,
        lineHeight: lineHeight.lineHeightT10
    };
    const noticeCon = {
        position: 'absolute',
        left: '50%',
        zIndex: 999
    };
    return {
        itemCon,
        topCon,
        topConSmall,
        text,
        noticeCon
    };
};
export default getStyle;
